<template>
  <SysDataTableExpand
    :headers="CABECALHOS"
    :height="alturaDaJanela - 222"
    :item-height="45"
    :itemClass="cssLinha"
    :callbacks="CALLBACKS"
    @click:row="exportarDadosLinha"
    @callback-resetar-grid="fn => callbackResetarDadosGrid = fn"
  >
    <template #header>
      <tr class="font-12 text-gray-800 text-center font-weight-bold z-999 bg-white">
        <td colspan="2" />
        <td colspan="2" class="border-gray-500 border-b-none">Estoque atual ({{ tipo_visao === 'F' ? 'R$ preço custo' : 'quantidade' }})</td>
        <td colspan="3" class="border-gray-500 border-b-none border-l-none">Estoque ideal Systock ({{ tipo_visao === 'F' ? 'R$ preço custo' : 'quantidade' }})</td>
        <td colspan="3" class="border-gray-500 border-b-none border-l-none">Estoque parametrizado ({{ tipo_visao === 'F' ? 'R$ preço custo' : 'quantidade' }})</td>
      </tr>
    </template>

    <template #_item.descricao_analise="{item}">
      <div class="d-flex align-center">
        <DetalhesProduto 
          v-if="item.idproduto" 
          :produto="{ 
            id_grupo: item.idgrupo, 
            id_filial: 9999, 
            id_produto: item.idproduto,
            produto_eh_combinacao: item.produto_combinado
          }" />
        <span v-text="item.descricao_analise" class="text-truncate" />
      </div>
    </template>

    <template #item.qtde_produtos="{item}">
      {{ item.idproduto ? '-' : formatarNumero(item.qtde_produtos) }}
    </template>

    <template #item.cobertura_estoque="{value}">{{ `${formatarNumero(value)} dias` }}</template>
    <template #item.cobertura_ideal_systock="{value}">{{ `${formatarNumero(value)} dias` }}</template>
    <template #item.cobertura_parametrizavel="{value}">{{ `${formatarNumero(value)} dias` }}</template>

    <template #item.estoque_em_preco_custo="{value}">{{ formatarDinheiro(value) }}</template>
    <template #item.estoque_ideal_systock_em_preco_custo="{value}">{{ formatarDinheiro(value) }}</template>
    <template #item.excesso_atual_em_preco_custo="{value}">{{ formatarDinheiro(value) }}</template>
    <template #item.estoque_parametrizado_em_preco_custo="{value}">{{ formatarDinheiro(value) }}</template>
    <template #item.excesso_acima_do_parametrizado_em_preco_custo="{value}">{{ formatarDinheiro(value) }}</template>
x
    <template #item.estoque="{value}">{{ formatarNumero(value) }}</template>
    <template #item.estoque_ideal_systock="{value}">{{ formatarNumero(value) }}</template>
    <template #item.excesso_atual="{value}">{{ formatarNumero(value) }}</template>
    <template #item.estoque_parametrizado="{value}">{{ formatarNumero(value) }}</template>
    <template #item.excesso_acima_do_parametrizado="{value}">{{ formatarNumero(value) }}</template>
  </SysDataTableExpand>
</template>

<script>
import SysDataTableExpand from "@/components/utils/dataTable/sysDataTableExpand/Index";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import {financeiro, quantitativo} from '@/components/Diagnostico/ExcessoEstoque/TiposCabecalhos';
import * as requisicoes from '@/api/Diagnostico/ExcessoEstoque';
import {formatarValor, formatarValorMonetario} from "@/helpers";
import DetalhesProduto from "@/components/produto/detalhes/Index";
import produto from "@/api/produto";

export default {
  name: "GridItens",
  mixins: [ResponsiveHeight],
  components: {
    SysDataTableExpand,
    DetalhesProduto
  },
  props: {
    tipo_visao: String
  },
  data: () => ({
    linha_clicada: null,
    callbackResetarDadosGrid: null,
    tipos_cabecalhos: {
      financeiro,
      quantitativo
    }
  }),
  computed: {
    GRUPO_COMPRA() {
      return this.$store.getters['usuario/getGrupoCompras'];
    },
    CABECALHOS() {
      return this.tipo_visao === 'F' ? this.tipos_cabecalhos.financeiro : this.tipos_cabecalhos.quantitativo;
    },
    FILTROS_STORE() {
      return this.$store.getters['filtrosUniversalAvancado/filtros_formatados'];
    },
    CALLBACKS() {
      const funcoes = [
        this.buscarExcessoTotalEExcessoPorSegmentos,
        this.buscarExcessoPorFornecedores,
        this.buscarExcessoPorProdutos,
      ];

      if (localStorage.diagnostico_ocultar_nivel_fornecedor === 'S') {
        return funcoes.filter(f => f !== this.buscarExcessoPorFornecedores);
      }

      return funcoes;
    }
  },
  watch: {
    GRUPO_COMPRA() {
      this.callbackResetarDadosGrid();
    },
    FILTROS_STORE() {
      this.callbackResetarDadosGrid();
    },
  },
  methods: {
    formatarNumero: formatarValor,
    formatarDinheiro: formatarValorMonetario,
    async buscarExcessoTotalEExcessoPorSegmentos()  {
      const parametros = {
        id_grupo: this.GRUPO_COMPRA,
        ...this.FILTROS_STORE
      };
      const {segmentos, totalizador} = await requisicoes.buscarExcessoTotalEExcessoPorSegmentos(parametros);

      totalizador.totalizador = true;
      totalizador.$nao_expansivel = true;
      segmentos.unshift(totalizador)

      return segmentos;
    },
    async buscarExcessoPorFornecedores(linha)  {
      if (linha.descricao_analise === 'COMBINADOS') {
        linha.produto_combinado = true;
        return await this.buscarExcessoPorProdutos(linha);
      }

      const parametros = {
        id_grupo: this.GRUPO_COMPRA,
        idsegmento: `${linha.idsegmento}`,
        ...this.FILTROS_STORE
      };
      return await requisicoes.buscarExcessoPorFornecedores(parametros);
    },
    async buscarExcessoPorProdutos({idfornecedor, idsegmento, produto_combinado}) {
      const parametros = {
        id_grupo: this.GRUPO_COMPRA,
        idsegmento: `${idsegmento}`,
        idfornecedor: `${idfornecedor || 0}`,
        produto_combinado: produto_combinado ? 'S' : 'N',
        ...this.FILTROS_STORE
      };
      const itens = await requisicoes.buscarExcessoPorProdutos(parametros);
      return itens.map(item => ({...item, $nao_expansivel: produto_combinado, produto_combinado}))
    },
    exportarDadosLinha({ row }) {
      if (this.linha_clicada === row) {
        this.$emit('duplo-click:linha', {...row});
      }

      this.linha_clicada = row;
      setTimeout(() => this.linha_clicada = null, 500);
    },
    cssLinha(linha) {
      return {
        'font-weight-bold': linha.totalizador,
        'cursor-pointer': true,
        'text-center': true,
      }
    }
  }
}
</script>

<style scoped>
</style>
